"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.error = void 0;
var general_1 = __importDefault(require("./general"));
/**
 * HTML Errors available.
 */
var errors = {
    general: general_1.default,
};
var error = function (options, error) { return "\n    <div class=\"chartisan-help-block\">\n    <div class=\"chartisan-refresh-chart\">\n        ".concat(errors[options.type](options), "\n    </div>\n    ").concat(options.text != ''
    ? "\n            <div class=\"chartisan-help-text\" style=\"color: ".concat(options.textColor, ";\">\n                ").concat(options.text, "\n            </div>\n            ")
    : '', "\n    ").concat(options.debug
    ? "\n            <div class=\"chartisan-help-text-error\">\n                ".concat(error.message, "\n            </div>")
    : '', "\n    </div>\n"); };
exports.error = error;
